import React from 'react';
import './canvas.css';
import PageBackdrop from '../page-backdrop/PageBackdrop';

interface ICanvasProps {}

const Canvas: React.FC<ICanvasProps> = () => {
	return (
		<div>
			<PageBackdrop />
			<div className='editor-canvas-container'></div>
		</div>
	);
};

export default Canvas;
